/**
 * Shared constants for the member (self-scoped) Projects dashboard widgets.
 *
 * The query-key root mirrors HR's `['hr', 'staff', 'dashboard', ...]` convention
 * so the single header refresh button can invalidate the whole dashboard via
 * `queryClient.invalidateQueries({ queryKey: MEMBER_DASHBOARD_KEY })`.
 */

/** Root query key for every member-dashboard widget. */
export const MEMBER_DASHBOARD_KEY = ['projects', 'member', 'dashboard'] as const;

/**
 * Task portal status IDs (mirrors TaskPortalDashboardService semantics):
 *   0 Unseen · 1 Seen It · 2 On It · 3 Done It · 4 Closed · -1 On Hold · -2 Re-Opened
 */
export const TASK_STATUS = {
  UNSEEN: 0,
  SEEN: 1,
  ON_IT: 2,
  DONE: 3,
  CLOSED: 4,
  ON_HOLD: -1,
  RE_OPENED: -2,
} as const;

/** Statuses that count as "open" work (everything except Done / Closed). */
export const OPEN_TASK_STATUS_IDS: ReadonlySet<number> = new Set([
  TASK_STATUS.UNSEEN,
  TASK_STATUS.SEEN,
  TASK_STATUS.ON_IT,
  TASK_STATUS.ON_HOLD,
  TASK_STATUS.RE_OPENED,
]);

/**
 * The task portal pages at 50 rows by default (before any ordering), so without an explicit
 * size users with more tasks get an arbitrary 50 and the open-task counts undercount.
 */
export const MY_TASKS_FILTER = { take: 1000 } as const;
